import React, { useState } from 'react';
import DetailsItem from 'evcharging/components/DetailsItem';
import Section from 'evcharging/containers/layout/Section';
import Container from 'evcharging/components/Container';
import Responsible from 'evcharging/components/Responsible';
import Box from 'evcharging/components/Box';
import Title from 'evcharging/components/Title';
import Spacer from 'evcharging/components/Spacer';
import Button from 'evcharging/components/Button';
import Desktop from 'evcharging/components/Desktop';
import Mobile from 'evcharging/components/Mobile';
import useI18n from 'evcharging/hooks/useI18n';

const TechnicalDetails = () => {
  const [more, setMore] = useState<boolean>(false);
  const { t } = useI18n();
  const items1 = [
    [t('charger.details.brand'), 'Energy5'],
    [t('charger.details.model'), 'PowerPump'],
    [t('charger.details.type'), 'Level 2 Charging station'],
    [t('charger.details.connector'), 'SAE J1772 Type 1'],
    [t('charger.details.full'), `~4-5 ${t('charger.details.hours')}`],
    [t('charger.details.temperature'), '-30 ~ 50 ℃ / -22 ~ 122 ℉'],
    [t('charger.details.resistance'), 'IK10'],
    [t('charger.details.weight'), '< 6kg'],
  ];

  const items2 = [
    [t('charger.details.capacity'), '7.2 - 7.7 kW'],
    [t('charger.details.connectivity'), `${t('charger.details.cellular')}/Wi-Fi (min. 1GB)`],
    [t('charger.details.voltage'), `208/240VAC, ${t('charger.details.phase')}`],
    [t('charger.details.length'), '18 ft.'],
    [t('charger.details.protocol'), 'OCPP 1.6'],
    [t('charger.details.performance'), 'NEMA 4'],
    [t('charger.details.dimension'), '11.14” x 7.56” x 3.11”'],
  ];
  const onClickMore = () => setMore(!more);

  return (
    <Section>
      <Container>
        <Spacer value={0} mobile={24} />
        <Title fontSize={24} variant={'h2'}>
          {t('charger.details.title')}
        </Title>
        <Spacer value={16} />
      </Container>
      <Container mobileFullWidth>
        <Responsible fractions={[50, 50]} space={0}>
          <Box>
            {items1.map(([name, value], index) => (
              <DetailsItem name={name} value={value} white={index % 2 === 1} key={name} />
            ))}
          </Box>
          <Desktop>
            <Box>
              {items2.map(([name, value], index) => (
                <DetailsItem name={name} value={value} white={index % 2 === 1} key={name} />
              ))}
            </Box>
          </Desktop>
        </Responsible>
        <Mobile>
          {more && (
            <Box>
              {items2.slice(0, -1).map(([name, value], index) => (
                <DetailsItem name={name} value={value} white={index % 2 === 0} key={name} />
              ))}
            </Box>
          )}
        </Mobile>
      </Container>
      <Mobile>
        <Container>
          <Spacer value={24} />
          <Button fullWidth onClick={onClickMore}>
            {more ? t('charger.details.less') : t('charger.details.more')}
          </Button>
        </Container>
      </Mobile>
    </Section>
  );
};

export default TechnicalDetails;
